import { isLive } from "Dotpulse.Basic/Resources/Private/Components/Variables";

/** Main Swiper **/
const Slider = (slider) => {
	const MainSwiper = new Swiper(slider, {
		loop: isLive,
		autoplay: isLive ? { delay: 5000 } : false,
		speed: 1000,
		pagination: {
			el: ".swiper-pagination",
			type: "bullets",
			clickable: true,
		},
		simulateTouch: isLive,
		spaceBetween: isLive ? 0 : 16,
		breakpoints: {
			992: {
				autoHeight: true,
			},
		},
	});

	const promotion = slider.closest(".promotion-container");
	if (promotion) {
		const backgroundSlider = promotion.querySelector(".background-swiper");
		if (backgroundSlider) {
			MainSwiper.controller.control = new Swiper(backgroundSlider, {
				loop: isLive,
				speed: 1000,
				effect: "fade",
				simulateTouch: false,
			});
		}
	}
};
document.querySelectorAll(".main-swiper").forEach((swiper) => {
	Slider(swiper);
});

/** Carousel **/
const closeAllFlippedSlides = (slider) => {
	const flippedSlides = slider.querySelectorAll(".swiper-slide.flipped");
	flippedSlides.forEach((slide) => {
		slide.classList.remove("flipped");
	});
};

const Carousel = (slider) => {
	let swiperInstance;

	try {
		swiperInstance = new Swiper(slider, {
			pagination: {
				el: ".swiper-pagination-carousel",
				type: "progressbar",
			},
			navigation: {
				nextEl: ".swiper-button-next",
				prevEl: ".swiper-button-prev",
			},
			simulateTouch: isLive,
			slidesPerView: 3,
			spaceBetween: 36,
			breakpoints: {
				544: {
					slidesPerView: 1,
					spaceBetween: 20,
				},
				768: {
					slidesPerView: 2,
					spaceBetween: 36,
				},
			},
			on: {
				slideChange: () => {
					closeAllFlippedSlides(slider);
				},
			},
		});
	} catch (error) {
		console.error("Failed to initialize Carousel:", error);
	}

	return swiperInstance;
};

const slides = document.querySelectorAll(".swiper-slide.has-back-side");

const toggleFlip = (event) => {
	const slide = event.currentTarget.closest(".swiper-slide");
	const carousel = slide.closest(".swiper-container");
	const flippedSlides = carousel.querySelectorAll(".swiper-slide.flipped");

	flippedSlides.forEach((flippedSlide) => {
		if (flippedSlide !== slide) {
			flippedSlide.classList.remove("flipped");
		}
	});

	slide.classList.toggle("flipped");
};

slides.forEach((slide) => {
	const flipOpenButton = slide.querySelector(".back-open");
	flipOpenButton.addEventListener("click", toggleFlip);
});

slides.forEach((slide) => {
	const flipCloseButton = slide.querySelector(".back-close");
	flipCloseButton.addEventListener("click", toggleFlip);
});

document.querySelectorAll(".carousel-swiper").forEach((swiper) => {
	try {
		const carouselInstance = Carousel(swiper);

		// Listen for slide change event on the carousel container
		swiper.addEventListener("slideChange", () => {
			const flippedSlides = swiper.querySelectorAll(".swiper-slide.flipped");
			if (flippedSlides.length > 0) {
				// If there are any flipped slides, close them
				closeAllFlippedSlides(swiper);
			}
		});

		// Listen for destroy event on the carousel instance
		carouselInstance.on("destroy", () => {
			const flippedSlides = swiper.querySelectorAll(".swiper-slide.flipped");
			if (flippedSlides.length > 0) {
				// If there are any flipped slides, close them
				closeAllFlippedSlides(swiper);
			}
		});
	} catch (error) {
		console.error("Failed to initialize Carousel:", error);
	}
});
document.addEventListener("keydown", function (event) {
	if (event.key === "Escape") {
		const activeSlide = document.querySelector(".swiper-slide-active");
		if (activeSlide) {
			activeSlide.classList.remove("flipped");
		}
	}
});
